import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {UseIsComingFromInitialFlowStoreType} from './types';

export const useIsComingFromInitialFlowStore = create(
	persist<UseIsComingFromInitialFlowStoreType>(
		set => ({
			isComingFromInitialFlow: undefined,
			setIsComingFromInitialFlow: isComing => set({isComingFromInitialFlow: isComing}),
			resetIsComingFromInitialFlow: () => set({isComingFromInitialFlow: undefined}),
		}),
		{
			name: 'isComingFromInitialFlow',
		},
	),
);
